/// <reference types="d3" />
/// <reference path="util.ts" />
/// <reference path="localization.ts" />
/// <reference path="data.ts" />
/// <reference path="ui.ts" />

const API_URL =
    window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
        ? "http://localhost:8081/"
        : "https://fetch-forecast-thmhqixcza-ew.a.run.app/";

// init initializes the application. It is called when this script is executed.
function init() {
    setLang();
    initUI();
    fetchWeatherData();
}

document.addEventListener("DOMContentLoaded", init);
